/**
 * 관리자 Route
 * --
 */
import React, { useEffect, useState } from 'react';
import { AdminLayout, PrivateRoute } from 'components';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import {
  BarcodeOutlined,
  BarsOutlined,
  DollarOutlined,
  ProjectOutlined,
  SettingOutlined,
  ShopOutlined,
  SolutionOutlined,
  StarOutlined,
  UserOutlined,
  CoffeeOutlined,
  SearchOutlined,
  TruckOutlined,
  IdcardOutlined,
  WalletOutlined,
  ShoppingCartOutlined,
  FundProjectionScreenOutlined,
  TagsOutlined,
  MailOutlined,
  MessageOutlined,
  GiftOutlined,
  CreditCardOutlined,
  HomeOutlined,
  AreaChartOutlined,
} from '@ant-design/icons';
import { useUserAction, useUserStack } from 'store';
import { useAuthCheck } from 'hooks/AuthHooks';
import { deleteCookie, DEPLOY_TYPE, DOMAIN_URL, getCookie } from 'utils';

// Route
import AdminHome from './AdminHome';
import {
  UserDashboard,
  UserDetail,
  UserPeriodList,
  UserPointHistory,
  UserRegister,
  UserCouponList,
  UserGradeList,
  UserStampHistory,
  GradeBenefit,
} from './admin.users';
import { RatingDetail, RatingList, RatingRegister } from './admin.rating';
import {
  ProductAuditList,
  ProductDetail,
  ProductList,
  ProductOrderList,
  ProductRegister,
} from './admin.products';
import {
  PromotionDetail,
  PromotionList,
  PromotionRegister,
  ProposalDetail,
  ProposalList,
  CouponList,
  CouponRegister,
  RecipeList,
  RecipeRegister,
} from './admin.promotion';
import { ChargeList } from './admin.charge';
import {
  CalculateApplication,
  CalculateDetail,
  CalculateList,
} from './admin.calculate';
import { NoticeDetail, NoticeList } from './admin.notice';
import { EventList } from './admin.event';
import { PopupDetail, PopupList } from './admin.popup';
import { BannerDetail, BannerList } from './admin.banner';
import { PolicyDetail, PolicyList } from './admin.policy';
import ForwardingLocation from './admin.forwardingLocation';
import { SEOList, SEOMain } from './admin.seo';
import { ReviewDetail, ReviewList } from './admin.review';
import {
  BrandAuditDetail,
  BrandAuditList,
  BrandDashboard,
  BrandDetail,
  BrandList,
} from './admin.brand';
import {
  StoreDetail,
  StoreList,
  StoreRegister,
  StoreReceipt,
} from './admin.stores';
import {
  CategoryList,
  CategoryRequestList,
  ProductCategoryList,
} from './admin.categories';
import {
  MenuDetail,
  MenuList,
  MenuRegister,
  MenuRequestList,
} from './admin.menus';
import { TagDetail, TagList, TagRegister } from './admin.tags';
import {
  SearchWordDetail,
  SearchWordList,
  SearchWordRegister,
} from './admin.searchword';
import { ManagerList, ManagerRegister } from './admin.managers';
import { InquiryList } from './admin.inquiry';
import {
  MessageTemplate,
  EmailList,
  SMSList,
  NotificationList,
  PushManager,
  AlimTalk,
} from './admin.message';
import {
  StatisticDashboard,
  StatisticDetail,
  StatisticList,
} from './admin.statistics';
import { CartAnalyze, CartList, CartSettings } from './admin.cart';
import {
  SaleDashboard,
  SaleDetail,
  SaleList,
  JmPay,
  SaleRegister,
  ShopSales,
  ShopSalesDashboard,
} from './admin.sale';
import {
  Manual,
  OrderList,
  PaymentList,
  RefundList,
  RegularList,
  RentList,
  ShippingList,
  // RentList,
} from './admin.orders';
import {
  GiftCategoryList,
  GiftDashboard,
  GiftDetail,
  GiftList,
  GiftProductDetail,
  GiftProductList,
} from './admin.gift';
import Auth from './admin.auth';
import Apply from './admin.apply';
import { useGetShopInformation } from 'hooks/ShopInformationHooks';
// 대시보드 컴포넌트
import {
  OrderDashboard,
  ReviewDashboard,
  UserDashboard as UserDashboard2,
  JmPayDashboard,
  ProductDashboard,
  SalesDashboard,
  HomeDashboard,
  CouponDashboard,
  BoardDashboard,
  MessageDashboard,
} from './admin.dashboard';

import {
  PresentList,
  PresentCardList,
  PresentDashboard,
} from './admin.present';
const AdminRoutes = () => {
  /* ===== ROUTE ===== */
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  /* ===== Actions ===== */
  // 유저 Store
  const userStack = useUserStack();
  // 유저 Store Action
  const userAction = useUserAction();

  /* ===== Mutate ===== */
  // 토큰 검증
  const { authCheck } = useAuthCheck();
  // 쇼핑몰 단일 조회
  const { data: shopInformation, refetch: shopInformationRefetch } =
    useGetShopInformation(userStack?.shop_information_id);

  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  // 사이드메뉴 선택 키
  const [selectedKeys, setSelectedKeys] = useState(['']);
  const [parentPath, setParentPath] = useState('');
  const [currentPath, setCurrentPath] = useState(pathname);

  /* ===== Variable ===== */
  // 사이드 메뉴
  const menu = [
    {
      key: '/main',
      icon: <HomeOutlined />,
      label: 'JM그룹 전체 홈',
      // children: [],
      onClick: () => navigate(`/main`),
    },
    {
      key: '/order/management',
      icon: <TruckOutlined />,
      label: '쇼핑몰 쇼핑몰 주문 관리',
      children: [
        {
          key: '/order/dashboard',
          label: '쇼핑몰관리 홈',
          icon: null,
          onClick: () => navigate(`/order/dashboard`),
        },
        // {
        //   key: '/order/list',
        //   label: '주문 목록',
        //   icon: null,
        //   onClick: () => navigate(`/order/list`),
        // },
        // {
        //   key: '/payment/list',
        //   label: '결제 목록',
        //   icon: null,
        //   onClick: () => navigate(`/payment/list`),
        // },

        /* ===== 신규: ===== */
        {
          key: '/order/list/all',
          label: '전체주문조회',
          icon: null,
          onClick: () => navigate(`/order/list`),
        },
        {
          key: '/order/list/PENDING',
          label: '입금전 관리',
          icon: null,
          onClick: () => navigate(`/order/list/PENDING`),
        },
        {
          key: '/shipping/list/PENDING',
          label: '상품 준비중',
          icon: null,
          onClick: () => navigate(`/shipping/list/PENDING`),
        },
        {
          key: '/shipping/list/PREPARING',
          label: '배송 준비중',
          icon: null,
          onClick: () => navigate(`/shipping/list/PREPARING`),
        },
        // {
        //   key: '/shipping/list/PREPARING',
        //   label: '상품 준비중',
        //   icon: null,
        //   onClick: () => navigate(`/shipping/list/PREPARING`),
        // },
        // {
        //   key: '/shipping/list/PREPARING',
        //   label: '배송 준비중',
        //   icon: null,
        //   onClick: () => navigate(`/shipping/list/PREPARING`),
        // },
        {
          key: '/shipping/list/ON_HOLD',
          label: '배송 보류',
          icon: null,
          onClick: () => navigate(`/shipping/list/ON_HOLD`),
        },
        {
          key: '/shipping/list/SHIPPING',
          label: '배송 중',
          icon: null,
          onClick: () => navigate(`/shipping/list/SHIPPING`),
        },
        {
          key: '/shipping/list/DELIVERED',
          label: '배송 완료',
          icon: null,
          onClick: () => navigate(`/shipping/list/DELIVERED`),
        },
        {
          key: '/shipping/list/RENTAL',
          label: '렌탈상품관리',
          icon: null,
          onClick: () => navigate(`/shipping/list/RENTAL`),
        },
        {
          key: '/shipping/list/REGULAR',
          label: '정기배송관리',
          icon: null,
          onClick: () => navigate(`/shipping/list/REGULAR`),
        },
        {
          key: '/shipping/list/EXCHANGE_REQUESTED',
          label: '교환 신청',
          icon: null,
          onClick: () => navigate(`/shipping/list/EXCHANGE_REQUESTED`),
        },
        {
          key: '/shipping/list/RETURN_REQUESTED',
          label: '반품 신청',
          icon: null,
          onClick: () => navigate(`/shipping/list/RETURN_REQUESTED`),
        },
        {
          key: '/refund/list',
          label: '교환/반품/환불 처리완료',
          icon: null,
          onClick: () => navigate(`/refund/list`),
        },
        /* ===== 신규: ===== */

        // {
        //   key: '/shipping/list',
        //   label: '배송 목록',
        //   icon: null,
        //   onClick: () => navigate(`/shipping/list`),
        // },
        // {
        //   key: '/regular/list',
        //   label: '정기배송 목록',
        //   icon: null,
        //   onClick: () => navigate(`/regular/list`),
        // },
        // {
        //   key: '/rent/list',
        //   label: '렌탈 목록',
        //   icon: null,
        //   onClick: () => navigate(`/rent/list`),
        // },
        // {
        //   key: '/refund/list',
        //   label: '환불/반품 목록',
        //   icon: null,
        //   onClick: () => navigate(`/refund/list`),
        // },
        {
          key: '/order/manual',
          label: '주문장 생성',
          icon: null,
          onClick: () => navigate(`/order/manual`),
        },
      ],
      type: null,
    },

    {
      key: '/shop/sales',
      icon: <AreaChartOutlined />,
      label: '쇼핑몰 매출 관리',
      children: [
        {
          key: '/shop/sales/dashboard',
          label: '대시보드',
          icon: null,
          onClick: () => navigate(`/shop/sales/dashboard`),
        },
        {
          key: '/shop/sales/daily',
          label: '일자별',
          icon: null,
          onClick: () => navigate(`/shop/sales/daily`),
        },
        {
          key: '/shop/sales/timezone',
          label: '시간대별',
          icon: null,
          onClick: () => navigate(`/shop/sales/timezone`),
        },
        {
          key: '/shop/sales/products',
          label: '상품별',
          icon: null,
          onClick: () => navigate(`/shop/sales/products`),
        },
        {
          key: '/shop/sales/payments',
          label: '결제수단별',
          icon: null,
          onClick: () => navigate(`/shop/sales/payments`),
        },
        {
          key: '/shop/sales/category',
          label: '카테고리별',
          icon: null,
          onClick: () => navigate(`/shop/sales/category`),
        },
      ],
      type: null,
    },

    // ===== 쇼핑몰 상품/재고 관리 ===== //
    {
      key: '/product/management',
      icon: <BarcodeOutlined />,
      label: '쇼핑몰 상품/재고 관리',
      children: [
        {
          key: '/product/dashboard',
          label: '상품 대시보드',
          icon: null,
          onClick: () => navigate(`/product/dashboard`),
        },
        {
          key: '/product/list',
          label: '상품 목록',
          icon: null,
          onClick: () => navigate(`/product/list`),
        },
        {
          key: '/product/register',
          label: '상품 등록',
          icon: null,
          onClick: () => navigate(`/product/register`),
        },
        // {
        //   key: '/product-order/list',
        //   label: '발주 목록',
        //   icon: null,
        //   onClick: () => navigate(`/product-order/list`),
        // },
        {
          key: '/product-audit/list',
          label: '상품심사 목록',
          icon: null,
          onClick: () => navigate(`/product-audit/list`),
        },
        {
          key: '/categories/product/list',
          label: '상품 카테고리 관리',
          icon: null,
          onClick: () => navigate(`/categories/product/list`),
        },
        // ======= 태그관리 추가
        {
          key: '/tag/detail',
          label: '태그 상세정보',
          icon: null,
          onClick: () => navigate(`/tag/detail`),
        },
        {
          key: '/tag/register',
          label: '태그 등록/수정',
          icon: null,
          onClick: () => navigate(`/tag/register`),
        },
        //  ===== 추천 검색어
        {
          key: '/searchword/detail',
          label: '추천검색어 상세정보',
          icon: null,
          onClick: () => navigate(`/searchword/detail`),
        },
        {
          key: '/searchword/register',
          label: '추천검색어 등록/수정',
          icon: null,
          onClick: () => navigate(`/searchword/register`),
        },
      ],
      type: null,
    },

    // ===== 태그관리 ===== //
    // {
    //   key: '/tag/management',
    //   icon: <TagsOutlined />,
    //   label: '쇼핑몰 상품/재고 관리',
    //   children: [
    //     // {
    //     //   key: '/tag/list',
    //     //   label: '태그 목록',
    //     //   icon: null,
    //     //   onClick: () => navigate(`/tag/list`),
    //     // },
    //     {
    //       key: '/tag/detail',
    //       label: '태그 상세정보',
    //       icon: null,
    //       onClick: () => navigate(`/tag/detail`),
    //     },
    //     {
    //       key: '/tag/register',
    //       label: '태그 등록/수정',
    //       icon: null,
    //       onClick: () => navigate(`/tag/register`),
    //     },
    //   ],
    //   type: null,
    // },

    // ===== 쇼핑몰 장바구니 관리 ===== //
    {
      key: '/cart/management',
      icon: <ShoppingCartOutlined />,
      label: '쇼핑몰 장바구니 관리',
      children: [
        {
          key: '/cart/analyze',
          label: '쇼핑몰 장바구니 분석',
          icon: null,
          onClick: () => navigate(`/cart/analyze`),
        },
        {
          key: '/cart/setting',
          label: '쇼핑몰 장바구니 설정',
          icon: null,
          onClick: () => navigate(`/cart/settings`),
        },
      ],
      type: null,
    },

    // ===== 매장 관리 ===== //
    {
      key: '/store/management',
      icon: <ShopOutlined />,
      label: '매장 관리',
      children: [
        {
          key: '/store/list',
          label: '매장 관리',
          icon: null,
          onClick: () => navigate(`/store/list`),
        },
        {
          key: '/store/register',
          label: '매장 등록',
          icon: null,
          onClick: () => navigate(`/store/register`),
        },
        {
          key: '/store/receipt',
          label: '매장별 영수증 관리',
          icon: null,
          onClick: () => navigate(`/store/receipt`),
        },
      ],
      type: null,
    },

    // ===== 매장매출 관리 ===== //
    {
      key: '/sales/management',
      icon: <WalletOutlined />,
      label: '매장매출 관리',
      children: [
        {
          key: '/sales/dashboard',
          label: '대시보드',
          icon: null,
          onClick: () => navigate(`/sales/dashboard`),
        },
        // {
        //   key: '/sales/dashboard/jm-pay',
        //   label: 'JM페이',
        //   icon: null,
        //   onClick: () => navigate(`/sales/dashboard/jm-pay`),
        // },
        {
          key: '/sales/dashboard/daily',
          label: '일자별',
          icon: null,
          onClick: () => navigate(`/sales/dashboard/daily`),
        },
        {
          key: '/sales/dashboard/timezone',
          label: '시간대별',
          icon: null,
          onClick: () => navigate(`/sales/dashboard/timezone`),
        },
        {
          key: '/sales/dashboard/menu',
          label: '메뉴별',
          icon: null,
          onClick: () => navigate(`/sales/dashboard/menu`),
        },
        {
          key: '/sales/dashboard/option_period',
          label: '옵션별',
          icon: null,
          onClick: () => navigate(`/sales/dashboard/option_period`),
        },

        {
          key: '/sales/dashboard/payments',
          label: '결제수단별',
          icon: null,
          onClick: () => navigate(`/sales/dashboard/payments`),
        },
        {
          key: '/sales/dashboard/menu_category',
          label: '카테고리별',
          icon: null,
          onClick: () => navigate(`/sales/dashboard/menu_category`),
        },
        {
          key: '/sales/register',
          label: '주문장 생성',
          icon: null,
          onClick: () => navigate(`/sales/register`),
        },
        // {
        //   key: '/sales/dashboard/order',
        //   label: '매장통계',
        //   icon: null,
        //   onClick: () => navigate(`/sales/dashboard/order`),
        // },
        // {
        //   key: '/sales/dashboard/mall',
        //   label: '쇼핑몰통계',
        //   icon: null,
        //   onClick: () => navigate(`/sales/dashboard/mall`),
        // },
        // {
        //   key: 'sales-list',
        //   label: '매출 목록',
        //   icon: null,
        //   onClick: () => navigate(`/sales/list`),
        // },
        // {
        //   key: 'store-sales-list',
        //   label: '매장매출 목록',
        //   icon: null,
        //   onClick: () => navigate(`/store-sales/list`),
        // },
      ],
      type: null,
    },

    // ===== 매장메뉴/재고 관리 ===== //
    {
      key: '/menu/management',
      icon: <CoffeeOutlined />,
      // label: '매장 메뉴 관리',
      label: '매장메뉴/재고 관리',
      children: [
        {
          key: '/menu/list',
          label: '매장 메뉴 목록',
          icon: null,
          onClick: () => navigate(`/menu/list`),
        },
        // {
        //   key: '/menu/register',
        //   label: '메뉴 등록',
        //   icon: null,
        //   onClick: () => navigate(`/menu/register`),
        // },
        // {
        //   key: '/menu/request-list',
        //   label: '매장 메뉴 신청 목록',
        //   icon: null,
        //   onClick: () => navigate(`/menu/request-list`),
        // },
        {
          key: '/categories/list',
          label: '매장 메뉴 카테고리 관리',
          icon: null,
          onClick: () => navigate(`/categories/list`),
        },
      ],
      type: null,
    },

    // ===== 회원관리 ===== //
    {
      key: '/user/management',
      icon: <UserOutlined />,
      label: '회원 관리',
      children: [
        {
          key: '/users/dashboard',
          label: '대시보드',
          icon: null,
          onClick: () => navigate(`/users/dashboard`),
        },
        {
          key: '/users/list',
          label: '회원 목록',
          icon: null,
          onClick: () => navigate(`/users/list`),
        },
        // {
        //   key: '/users/period',
        //   // key: 'users-period-list',
        //   label: '기간별 회원 목록',
        //   icon: null,
        //   onClick: () => navigate(`/users/period`),
        // },
        {
          key: '/users/rating',
          label: '회원등급 관리',
          icon: null,
          onClick: () => navigate(`/users/rating`),
        },
        {
          key: '/users/grade/list',
          label: '등급 변동 내역',
          icon: null,
          onClick: () => navigate(`/users/grade/list`),
        },
        {
          key: '/users/point_history',
          label: '포인트 사용 내역',
          icon: null,
          onClick: () => navigate(`/users/point_history`),
        },
        {
          key: '/users/stamp_history',
          label: '스탬프 내역',
          icon: null,
          onClick: () => navigate(`/users/stamp_history`),
        },
        {
          key: '/users/coupon/list',
          label: '쿠폰 발급 내역',
          icon: null,
          onClick: () => navigate(`/users/coupon/list`),
        },
      ],
      type: null,
    },
    // ===== 회원관리 ===== //

    // ===== 메시지 관리 ===== //
    {
      key: '/message-management',
      icon: <MessageOutlined />,
      label: '메시지 관리',
      children: [
        // {
        //   key: '/message/dashboard',
        //   label: '메시지 대시보드',
        //   icon: null,
        //   onClick: () => navigate(`/message/dashboard`),
        // },
        {
          key: '/message/list/email',
          label: '이메일 전송내역',
          icon: null,
          onClick: () => navigate(`/message/list/email`),
        },
        {
          key: '/message/list/sms',
          label: '문자 전송내역',
          icon: null,
          onClick: () => navigate(`/message/list/sms`),
        },
        {
          key: '/message/list/notification',
          label: '푸시알림 전송내역',
          icon: null,
          onClick: () => navigate(`/message/list/notification`),
        },
        {
          key: '/message/push-manager',
          label: '푸시알림 발송',
          icon: null,
          onClick: () => navigate(`/message/push-manager`),
        },
        {
          key: '/message/sms-manager',
          label: '문자 발송',
          icon: null,
          onClick: () => navigate(`/message/sms-manager`),
        },
        {
          key: '/message/email-manager',
          label: '이메일 발송',
          icon: null,
          onClick: () => navigate(`/message/email-manager`),
        },
        // {
        //   key: '/message/alim-manager',
        //   label: '알림톡 발송',
        //   icon: null,
        //   onClick: () => navigate(`/message/alim-manager`),
        // },
        {
          key: '/message/template',
          label: '템플릿 관리',
          icon: null,
          onClick: () => navigate(`/message/template`),
        },
        {
          key: '/alim-talk',
          label: '알림톡 관리',
          icon: null,
          onClick: () => navigate(`/alim-talk`),
        },
      ],
      type: null,
    },

    // ===== 게시판 관리 ===== //
    {
      key: '/site/management',
      icon: <SettingOutlined />,
      label: '게시판 관리',
      children: [
        {
          key: '/site/dashboard',
          label: '게시판 대시보드',
          icon: null,
          onClick: () => navigate(`/site/dashboard`),
        },
        {
          key: '/notice/list',
          label: '공지사항 관리',
          icon: null,
          onClick: () => navigate(`/notice/list`),
        },
        {
          key: '/event/list',
          label: '이벤트 관리',
          icon: null,
          onClick: () => navigate(`/event/list`),
        },
        {
          key: '/popup/list',
          label: '팝업 관리',
          icon: null,
          onClick: () => navigate(`/popup/list`),
        },
        {
          key: '/banner/list',
          label: '배너 관리',
          icon: null,
          onClick: () => navigate(`/banner/list`),
        },
        {
          key: '/policy/list',
          label: '정책 관리',
          icon: null,
          onClick: () => navigate(`/policy/list`),
        },
        {
          key: '/forwarding/location',
          label: '출고지 관리',
          icon: null,
          onClick: () => navigate(`/forwarding/location`),
        },
        {
          key: '/seo/list',
          label: '검색엔진 최적화 관리(SEO)',
          icon: null,
          onClick: () => navigate(`/seo/list`),
        },
        // ===== 리뷰 관리
        {
          key: '/review/dashboard',
          label: '리뷰 대시보드',
          icon: null,
          onClick: () => navigate(`/review/dashboard`),
        },
        {
          key: '/review/list',
          label: '리뷰 목록',
          icon: null,
          onClick: () => navigate(`/review/list`),
        },
        // ===== 문의 목록
        {
          key: '/inquiry/list',
          label: '문의 목록',
          icon: null,
          onClick: () => navigate(`/inquiry/list`),
        },
        {
          key: '/inquiry/faq',
          label: 'FAQ 목록',
          icon: null,
          onClick: () => navigate(`/inquiry/faq`),
        },
      ],
      type: null,
    },
    // ===== 선물 관리 ===== //
    {
      key: '/present/management',
      icon: <GiftOutlined />,
      label: '선물 관리',
      children: [
        {
          key: '/present/dashboard',
          label: '선물 대시보드',
          icon: null,
          onClick: () => navigate(`/present/dashboard`),
        },
        {
          key: '/present/card/list',
          label: '선물 카드 관리',
          icon: null,
          onClick: () => navigate(`/present/card/list`),
        },
        {
          key: '/present/list',
          label: '선물 내역',
          icon: null,
          onClick: () => navigate(`/present/list`),
        },
      ],
      type: null,
    },
    // ===== ===== //
    {
      key: '/promotion/management',
      icon: <ProjectOutlined />,
      label: '프로모션 관리',
      children: [
        // {
        //   key: '/proposal/list',
        //   label: '프로모션 제안 목록',
        //   icon: null,
        //   onClick: () => navigate(`/proposal/list`),
        // },
        {
          key: '/coupon/dashboard',
          label: '대시보드',
          icon: null,
          onClick: () => navigate(`/coupon/dashboard`),
        },
        {
          key: '/coupon/list',
          label: '쿠폰 목록',
          icon: null,
          onClick: () => navigate(`/coupon/list`),
        },
        {
          key: '/coupon/register/menu',
          label: '메뉴 쿠폰 등록',
          icon: null,
          onClick: () => navigate(`/coupon/register/menu`),
        },
        {
          key: '/coupon/register/product',
          label: '상품 쿠폰 등록',
          icon: null,
          onClick: () => navigate(`/coupon/register/product`),
        },

        {
          key: '/promotion/list',
          label: '프로모션 목록',
          icon: null,
          onClick: () => navigate(`/promotion/list`),
        },
        {
          key: '/promotion/register',
          label: '프로모션 등록',
          icon: null,
          onClick: () => navigate(`/promotion/register`),
        },
        {
          key: '/recipe/list',
          label: '레시피 상품 목록',
          icon: null,
          onClick: () => navigate(`/recipe/list`),
        },
        {
          key: '/recipe/register',
          label: '레시피 상품 등록',
          icon: null,
          onClick: () => navigate(`/recipe/register`),
        },
      ],
      type: null,
    },

    // ===== 입점업체 관리 ===== //
    {
      key: '/brand/management',
      icon: <SolutionOutlined />,
      label: '입점업체 관리',
      children: [
        // {
        //   key: '/brand/dashboard',
        //   label: '대시보드',
        //   icon: null,
        //   onClick: () => navigate(`/brand/dashboard`),
        // },
        {
          key: '/brand/list',
          label: '입점업체 목록',
          icon: null,
          onClick: () => navigate(`/brand/list`),
        },
        {
          key: '/brand/register',
          label: '입점업체 등록',
          icon: null,
          onClick: () => navigate(`/apply?mode=admin`),
          // onClick: () => {
          //   window.open('/apply', '_blank', 'width=1100, height=980');
          // },
        },
        // {
        //   key: '/brand-audit/list',
        //   label: '입점심사 목록',
        //   icon: null,
        //   onClick: () => navigate(`/brand-audit/list`),
        // },

        // ===== 정산 관리
        {
          key: '/calculate/list',
          label: '정산내역 조회',
          icon: null,
          onClick: () => navigate(`/calculate/list`),
        },
        {
          key: '/calculate/application',
          label: '출금신청 목록',
          icon: null,
          onClick: () => navigate(`/calculate/application`),
        },
        {
          key: '/calculate/charge',
          label: '수수료 관리',
          icon: null,
          onClick: () => navigate(`/calculate/charge`),
        },

        // ====== 관리자 관리
        {
          key: '/manager/list',
          label: '관리자 목록',
          icon: null,
          onClick: () => navigate(`/manager/list`),
        },
        {
          key: '/manager/register',
          label: '관리자 등록',
          icon: null,
          onClick: () => navigate(`/manager/register`),
        },
      ],
      type: null,
    },

    // ===== ===== //
    // {
    //   key: '/calculate/management',
    //   icon: <DollarOutlined />,
    //   label: '정산 관리',
    //   children: [
    //     {
    //       key: '/calculate/list',
    //       label: '정산내역 조회',
    //       icon: null,
    //       onClick: () => navigate(`/calculate/list`),
    //     },
    //     {
    //       key: '/calculate/application',
    //       label: '출금신청 목록',
    //       icon: null,
    //       onClick: () => navigate(`/calculate/application`),
    //     },
    //     {
    //       key: '/calculate/charge',
    //       label: '수수료 관리',
    //       icon: null,
    //       onClick: () => navigate(`/calculate/charge`),
    //     },
    //   ],
    //   type: null,
    // },

    // ===== JM페이 ===== //
    {
      key: '/jm-pay/management',
      icon: <CreditCardOutlined />,
      label: 'JM페이',
      children: [
        {
          key: '/jm-pay',
          label: '대시보드',
          icon: null,
          onClick: () => navigate(`/jm-pay`),
        },
        {
          key: '/jm-pay/list',
          label: '사용 및 충전관리',
          icon: null,
          onClick: () => navigate(`/jm-pay/list`),
        },
      ],
    },

    // {
    //   key: '/statistics/management',
    //   icon: <FundProjectionScreenOutlined />,
    //   label: '통계 관리',
    //   children: [
    //     {
    //       key: '/statistics/dashboard',
    //       label: '대시보드',
    //       icon: null,
    //       onClick: () => navigate(`/statistics/dashboard`),
    //     },
    //   ],
    //   type: null,
    // },

    // ===== ===== //
    // {
    //   key: '/review/management',
    //   icon: <StarOutlined />,
    //   label: '리뷰 관리',
    //   children: [
    //     {
    //       key: '/review/dashboard',
    //       label: '리뷰 대시보드',
    //       icon: null,
    //       onClick: () => navigate(`/review/dashboard`),
    //     },
    //     {
    //       key: '/review/list',
    //       label: '리뷰 목록',
    //       icon: null,
    //       onClick: () => navigate(`/review/list`),
    //     },
    //   ],
    //   type: null,
    // },

    // {
    //   key: '/gift/management',
    //   icon: <GiftOutlined />,
    //   label: '선물 관리',
    //   children: [
    //     {
    //       key: '/gift/dashboard',
    //       label: '대시보드',
    //       icon: null,
    //       onClick: () => navigate(`/gift/dashboard`),
    //     },
    //     {
    //       key: '/gift/list',
    //       label: '선물 내역 관리',
    //       icon: null,
    //       onClick: () => navigate(`/gift/list`),
    //     },
    //     {
    //       key: '/gift/product',
    //       label: '선물 상품 관리',
    //       icon: null,
    //       onClick: () => navigate(`/gift/products`),
    //     },
    //     {
    //       key: '/gift/category',
    //       label: '선물 카테고리 관리',
    //       icon: null,
    //       onClick: () => navigate(`/gift/categories`),
    //     },
    //   ],
    //   type: null,
    // },

    // ===== ===== //
    // {
    //   key: '/searchword/management',
    //   icon: <SearchOutlined />,
    //   label: '쇼핑몰 상품/재고 관리',
    //   children: [
    //     // {
    //     //   key: '/searchword/list',
    //     //   label: '추천검색어 목록',
    //     //   icon: null,
    //     //   onClick: () => navigate(`/searchword/list`),
    //     // },
    //     {
    //       key: '/searchword/detail',
    //       label: '추천검색어 상세정보',
    //       icon: null,
    //       onClick: () => navigate(`/searchword/detail`),
    //     },
    //     {
    //       key: '/searchword/register',
    //       label: '추천검색어 등록/수정',
    //       icon: null,
    //       onClick: () => navigate(`/searchword/register`),
    //     },
    //   ],
    //   type: null,
    // },

    // ===== ===== //
    // {
    //   key: '/admin/management',
    //   icon: <IdcardOutlined />,
    //   label: '관리자 관리',
    //   children: [
    //     {
    //       key: '/manager/list',
    //       label: '관리자 목록',
    //       icon: null,
    //       onClick: () => navigate(`/manager/list`),
    //     },
    //     {
    //       key: '/manager/register',
    //       label: '관리자 등록',
    //       icon: null,
    //       onClick: () => navigate(`/manager/register`),
    //     },
    //   ],
    //   type: null,
    // },

    // ===== ===== //
    // {
    //   key: '/inquiry/management',
    //   icon: <MailOutlined />,
    //   label: '문의 관리',
    //   children: [
    //     {
    //       key: '/inquiry/list',
    //       label: '문의 목록',
    //       icon: null,
    //       onClick: () => navigate(`/inquiry/list`),
    //     },
    //     {
    //       key: '/inquiry/faq',
    //       label: 'FAQ 목록',
    //       icon: null,
    //       onClick: () => navigate(`/inquiry/faq`),
    //     },
    //   ],
    //   type: null,
    // },
  ];

  /* ===== FUNCTION ===== */
  /**
   * 라우트 권한 설정 + 상단 헤더 Breadcrumb 설정
   * --
   * @param {Object} props
   * @returns
   */
  const PrivateCheck = ({ auth = 'ADMIN', path, children }) => {
    return (
      <PrivateRoute auth={auth} path={path}>
        {children}
      </PrivateRoute>
    );
  };

  /**
   * 인증 토큰 검사
   * --
   */
  const handleTokenCheck = async () => {
    const { status, data } = await authCheck();

    if (status !== 200) {
      userAction.resetUser();
      deleteCookie('JM_COFFEE_ACCESS_TOKEN', {});
      return;
    }

    userAction.setUser(data);
    shopInformationRefetch();
  };

  /* ===== HOOKS ===== */
  /**
   * 토큰 / 권한 체크
   * --
   */
  useEffect(() => {
    const token = getCookie('JM_COFFEE_ACCESS_TOKEN');

    // NOTE: 토큰 없을 경우 처리
    if (!token) {
      userAction.resetUser();

      window.alert('세션이 만료되었습니다. 로그인 후 이용해주세요!');

      const protocol = window.location.protocol;
      const port = DEPLOY_TYPE === 'local' ? ':3000' : '';
      // const domain =
      //   DEPLOY_TYPE === 'development' ? `jm-coffee.${DOMAIN_URL}` : DOMAIN_URL;
      const domain =
        DEPLOY_TYPE === 'development'
          ? `mall-jm-coffee.${DOMAIN_URL}`
          : `mall.${DOMAIN_URL}`;
      return (window.location.href = `${protocol}//${domain}${port}/#/admin`);
    }

    const userInfo = userAction.getUser();
    // NOTE: 스토어에 저장된 값이 없을 경우 처리
    if (!userInfo) handleTokenCheck();

    // eslint-disable-next-line
  }, [navigate]);

  /**
   * 쇼핑몰 정보 스토어에 업데이트
   * --
   */
  useEffect(() => {
    const call = () => {
      const { data } = shopInformation;

      const { created_at, updated_at, type, ...d } = data;

      userAction.setUser({
        ...userStack,
        ...d,
      });
    };

    if (shopInformation && shopInformation.status === 200) {
      call();
    }
    // eslint-disable-next-line
  }, [shopInformation]);

  /**
   * 메뉴선택 및 새로고침 시 선택된 메뉴 유지 로직
   * --
   */
  useEffect(() => {
    const fid = menu.findIndex(
      ({ children }) => children?.findIndex(({ key }) => key === pathname) >= 0
    );
    if (fid >= 0) {
      setParentPath(menu[fid].key);
      setCurrentPath(pathname);
    }

    setCurrentPath(pathname);
    // alert(pathname);
  }, [pathname]);

  /* ===== RENDER ===== */
  return (
    <AdminLayout
      menu={menu}
      headerExceptPath={['certification', 'apply']}
      footerExceptPath={[]}
      siderExceptPath={['certification', 'apply']}
      selectedKeys={selectedKeys}
      onSelect={setSelectedKeys}
      brand={userStack?.shop_information_name}
      defaultSelectedKeys={[currentPath]}
      defaultOpenKeys={[parentPath]}
      // parentPath={parentPath}
      // currentPath={currentPath}
    >
      <Routes>
        {/* Auth Check */}
        <Route path="certification" element={<Auth />} />

        {/* 쇼핑몰 정보 입력 */}
        <Route path="apply" element={<Apply />} />

        {/* <Route path="main" element={<AdminHome />} /> */}
        <Route
          path="main"
          element={
            <PrivateCheck path={[{ title: 'JM그룹 전체 홈' }]}>
              <HomeDashboard />
            </PrivateCheck>
          }
        />
        {/* <Route path="main">
          <Route
            index
            element={
              <PrivateCheck
                path={[{ title: '회원 관리' }, { title: '대시보드' }]}
              >
                <HomeDashboard />
              </PrivateCheck>
            }
          />
        </Route> */}

        {/* 회원관리 */}
        <Route path="users">
          <Route
            index
            path="dashboard"
            element={
              <PrivateCheck
                path={[{ title: '회원 관리' }, { title: '대시보드' }]}
              >
                <UserDashboard2 />
                {/* <UserDashboard /> */}
              </PrivateCheck>
            }
          />
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '회원 관리' }, { title: '회원 목록' }]}
                >
                  <UserDashboard />
                  {/* <UserList /> */}
                </PrivateCheck>
              }
            />
            <Route path=":userId" element={<UserDetail />} />
          </Route>
          <Route
            path="period"
            element={
              <PrivateCheck
                path={[{ title: '회원 관리' }, { title: '기간별 회원 목록' }]}
              >
                <UserPeriodList />
              </PrivateCheck>
            }
          />
          <Route
            path="register"
            element={
              <PrivateCheck
                path={[{ title: '회원 관리' }, { title: '회원 등록/수정' }]}
              >
                <UserRegister />
              </PrivateCheck>
            }
          />
          <Route path="rating">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '회원 관리' }, { title: '회원등급 관리' }]}
                >
                  <RatingList />
                </PrivateCheck>
              }
            />

            <Route path=":ratingId" element={<RatingDetail />} />
            <Route
              path="register"
              element={
                <PrivateCheck
                  path={[
                    { title: '회원 관리' },
                    { title: '회원등급 관리' },
                    { title: '회원등급 생성' },
                  ]}
                >
                  <RatingRegister />
                </PrivateCheck>
              }
            />

            <Route
              path="setting"
              element={
                <PrivateCheck
                  path={[
                    { title: '회원 관리' },
                    { title: '회원등급 관리' },
                    { title: '회원등급 혜택설정' },
                  ]}
                >
                  <GradeBenefit />
                </PrivateCheck>
              }
            />
          </Route>
          <Route
            path="grade/list"
            element={
              <PrivateCheck
                path={[{ title: '회원 관리' }, { title: '등급 변동 내역' }]}
              >
                <UserGradeList />
              </PrivateCheck>
            }
          />
          <Route
            path="point_history"
            element={
              <PrivateCheck
                path={[{ title: '회원 관리' }, { title: '포인트 사용 내역' }]}
              >
                <UserPointHistory />
              </PrivateCheck>
            }
          />
          <Route
            path="stamp_history"
            element={
              <PrivateCheck
                path={[{ title: '회원 관리' }, { title: '스탬프 내역' }]}
              >
                <UserStampHistory />
              </PrivateCheck>
            }
          />
          <Route
            path="coupon/list"
            element={
              <PrivateCheck
                path={[{ title: '회원 관리' }, { title: '쿠폰 발급 내역' }]}
              >
                <UserCouponList />
              </PrivateCheck>
            }
          />
        </Route>
        {/* 회원관리 끝 */}

        {/* 상품/재고 */}
        <Route path="product">
          <Route path="dashboard">
            <Route
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 상품/재고 관리' },
                    { title: '상품 대시보드' },
                  ]}
                >
                  <ProductDashboard />
                </PrivateCheck>
              }
            />
            <Route path=":productId" element={<ProductDetail />} />
          </Route>
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 상품/재고 관리' },
                    { title: '상품 목록' },
                  ]}
                >
                  <ProductList />
                </PrivateCheck>
              }
            />
            <Route path=":productId" element={<ProductDetail />} />
          </Route>
          <Route
            path="register"
            element={
              <PrivateCheck
                path={[
                  { title: '쇼핑몰 상품/재고 관리' },
                  { title: '상품 등록' },
                ]}
              >
                <ProductRegister />
              </PrivateCheck>
            }
          />
        </Route>
        <Route path="product-order">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 상품/재고 관리' },
                    { title: '발주 등록' },
                  ]}
                >
                  <ProductOrderList />
                </PrivateCheck>
              }
            />
            <Route path=":orderId" element={<div>발주 상세</div>} />
          </Route>
        </Route>
        <Route path="product-audit">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 상품/재고 관리' },
                    { title: '상품심사 목록' },
                  ]}
                >
                  <ProductAuditList />
                </PrivateCheck>
              }
            />
            <Route path=":auditId" element={<div>상품심사 상세</div>} />
          </Route>
        </Route>
        {/* 상품/재고 끝 */}
        {/* 선물 관리 */}
        <Route path="present">
          <Route
            index
            path="dashboard"
            element={
              <PrivateCheck
                path={[{ title: '선물 관리' }, { title: '선물 대시보드' }]}
              >
                <PresentDashboard />
              </PrivateCheck>
            }
          />
          <Route
            path="list"
            element={
              <PrivateCheck
                path={[{ title: '선물 관리' }, { title: '선물 내역' }]}
              >
                <PresentList />
              </PrivateCheck>
            }
          />
          <Route
            path="card/list"
            element={
              <PrivateCheck
                path={[{ title: '선물 관리' }, { title: '선물 카드 관리' }]}
              >
                <PresentCardList />
              </PrivateCheck>
            }
          />
        </Route>
        {/* 선물 관리 끝*/}
        {/* 프로모션관리 */}
        <Route path="promotion">
          <Route
            path="list"
            element={
              <PrivateCheck
                path={[{ title: '프로모션 관리' }, { title: '프로모션 목록' }]}
              >
                <PromotionList />
              </PrivateCheck>
            }
          >
            <Route path=":promotionId" element={<PromotionDetail />} />
          </Route>
          <Route
            path="register"
            element={
              <PrivateCheck
                path={[
                  { title: '프로모션 관리' },
                  { title: '프로모션 생성/수정' },
                ]}
              >
                <PromotionRegister />
              </PrivateCheck>
            }
          />
        </Route>
        {/* 레시피 */}
        <Route path="recipe">
          <Route
            path="list"
            element={
              <PrivateCheck
                path={[
                  { title: '레시피 상품 관리' },
                  { title: '레시피 상품 목록' },
                ]}
              >
                <RecipeList />
              </PrivateCheck>
            }
          >
            <Route path=":recipeId" element={<RecipeList />} />
          </Route>
          <Route
            path="register"
            element={
              <PrivateCheck
                path={[
                  { title: '레시피 상품 관리' },
                  { title: '레시피 상품 생성/수정' },
                ]}
              >
                <RecipeRegister />
              </PrivateCheck>
            }
          />
        </Route>
        <Route path="proposal">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '프로모션 관리' },
                    { title: '프로모션 제안 목록' },
                  ]}
                >
                  <ProposalList />
                </PrivateCheck>
              }
            />
            <Route
              path=":proposalId"
              element={
                <PrivateCheck
                  path={[
                    { title: '프로모션 관리' },
                    { title: '프로모션 제안 상세정보' },
                  ]}
                >
                  <ProposalDetail />
                </PrivateCheck>
              }
            />
          </Route>
        </Route>
        <Route path="coupon">
          <Route path="dashboard">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '프로모션 관리' }, { title: '대시보드' }]}
                >
                  <CouponDashboard />
                </PrivateCheck>
              }
            />
          </Route>
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '프로모션 관리' }, { title: '쿠폰 목록' }]}
                >
                  <CouponList />
                </PrivateCheck>
              }
            />
          </Route>
          <Route path="register">
            <Route
              path=":type"
              element={
                <PrivateCheck
                  path={[
                    { title: '프로모션 관리' },
                    {
                      title: `${
                        pathname.includes('menu') ? '메뉴' : '상품'
                      } 쿠폰 등록`,
                    },
                  ]}
                >
                  <CouponRegister />
                </PrivateCheck>
              }
            />
          </Route>
        </Route>

        {/* 정산관리 */}
        <Route path="calculate">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '입점업체 관리' },
                    { title: '정산내역 조회' },
                  ]}
                >
                  <CalculateList />
                </PrivateCheck>
              }
            />
            <Route path=":calculateId" element={<CalculateDetail />} />
          </Route>
          <Route
            path="application"
            element={
              <PrivateCheck
                path={[{ title: '입점업체 관리' }, { title: '출금신청 목록' }]}
              >
                <CalculateApplication />
              </PrivateCheck>
            }
          />
          <Route
            path="charge"
            element={
              <PrivateCheck
                path={[{ title: '입점업체 관리' }, { title: '수수료 관리' }]}
              >
                <ChargeList />
              </PrivateCheck>
            }
          />
        </Route>
        {/* 정산관리 끝 */}

        {/* 게시판관리 */}
        <Route path="site">
          <Route path="dashboard">
            <Route
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '게시판 관리' },
                    { title: '게시판 대시보드' },
                  ]}
                >
                  <BoardDashboard />
                </PrivateCheck>
              }
            />
            <Route path=":noticeId" element={<NoticeDetail />} />
          </Route>
        </Route>
        <Route path="notice">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '게시판 관리' }, { title: '공지사항 관리' }]}
                >
                  <NoticeList />
                </PrivateCheck>
              }
            />
            <Route path=":noticeId" element={<NoticeDetail />} />
          </Route>
        </Route>
        <Route path="event">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '게시판 관리' }, { title: '이벤트 관리' }]}
                >
                  <EventList />
                </PrivateCheck>
              }
            />
            {/* <Route path=":eventId" element={<EventListDetail />} /> */}
          </Route>
        </Route>
        <Route path="popup">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '게시판 관리' }, { title: '팝업 관리' }]}
                >
                  <PopupList />
                </PrivateCheck>
              }
            />
            <Route path=":popupId" element={<PopupDetail />} />
          </Route>
        </Route>
        <Route path="banner">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '게시판 관리' }, { title: '배너 관리' }]}
                >
                  <BannerList />
                </PrivateCheck>
              }
            />
            <Route path=":bannerId" element={<BannerDetail />} />
          </Route>
        </Route>
        <Route path="policy">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '게시판 관리' }, { title: '정책 관리' }]}
                >
                  <PolicyList />
                </PrivateCheck>
              }
            />
            <Route path=":policyId" element={<PolicyDetail />} />
          </Route>
        </Route>
        {/* 출고지 관리 */}
        <Route path="forwarding">
          <Route path="location">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '게시판 관리' }, { title: '출고지 관리' }]}
                >
                  <ForwardingLocation />
                </PrivateCheck>
              }
            />
            <Route path=":policyId" element={<PolicyDetail />} />
          </Route>
        </Route>
        <Route path="seo">
          <Route index path="main" element={<SEOMain />} />
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '게시판 관리' },
                    { title: '검색엔진 최적화' },
                  ]}
                >
                  <SEOList />
                </PrivateCheck>
              }
            />
          </Route>
        </Route>
        {/* 게시판관리 끝 */}

        {/* 리뷰 */}
        <Route path="review">
          <Route
            index
            path="dashboard"
            element={
              <PrivateCheck
                path={[{ title: '게시판 관리' }, { title: '리뷰 대시보드' }]}
              >
                <ReviewDashboard />
              </PrivateCheck>
            }
          />
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '게시판 관리' }, { title: '리뷰 목록' }]}
                >
                  <ReviewList />
                </PrivateCheck>
              }
            />
            <Route
              path=":reviewId"
              element={
                <PrivateCheck
                  path={[{ title: '리뷰 관리' }, { title: '리뷰 상세정보' }]}
                >
                  <ReviewDetail />
                </PrivateCheck>
              }
            />
          </Route>
        </Route>
        {/* 리뷰 끝 */}

        {/* 입점업체 관리 */}
        <Route path="brand">
          <Route
            path="dashboard"
            element={
              <PrivateCheck
                path={[{ title: '입점업체 관리' }, { title: '대시보드' }]}
              >
                <BrandDashboard />
              </PrivateCheck>
            }
          />
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '입점업체 관리' }, { title: '입점 목록' }]}
                >
                  <BrandList />
                </PrivateCheck>
              }
            />
            <Route
              path=":brandId"
              element={
                <PrivateCheck
                  path={[
                    { title: '입점업체 관리' },
                    { title: '입점업체 상세정보' },
                  ]}
                >
                  <BrandDetail />
                </PrivateCheck>
              }
            />
          </Route>
        </Route>
        <Route path="brand-audit">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '입점업체 관리' },
                    { title: '입점심사 목록' },
                  ]}
                >
                  <BrandAuditList />
                </PrivateCheck>
              }
            />
            <Route
              path=":brandAuditId"
              element={
                <PrivateCheck
                  path={[
                    { title: '입점업체 관리' },
                    { title: '입점심사 상세정보' },
                  ]}
                >
                  <BrandAuditDetail />
                </PrivateCheck>
              }
            />
          </Route>
        </Route>
        {/* 입점업체 관리 끝 */}

        {/* 매장 관리 */}
        <Route path="store">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '매장 관리' }, { title: '매장 관리' }]}
                >
                  <StoreList />
                </PrivateCheck>
              }
            />
            <Route
              path=":storeId"
              element={
                <PrivateCheck
                  path={[{ title: '매장 관리' }, { title: '매장 상세정보' }]}
                >
                  <StoreDetail />
                </PrivateCheck>
              }
            />
          </Route>
          <Route
            path="register"
            element={
              <PrivateCheck
                path={[{ title: '매장 관리' }, { title: '매장 등록' }]}
              >
                <StoreRegister />
              </PrivateCheck>
            }
          />
          <Route
            path="receipt"
            element={
              <PrivateCheck
                path={[{ title: '매장 관리' }, { title: '매장별 영수증 관리' }]}
              >
                <StoreReceipt />
              </PrivateCheck>
            }
          />
        </Route>
        {/* 매장 관리 끝 */}

        {/* 카테고리 */}
        <Route path="categories">
          <Route
            path="list"
            element={
              <PrivateCheck
                path={[
                  { title: '매장 메뉴/재고 관리' },
                  { title: '매장 메뉴 카테고리 관리' },
                ]}
              >
                <CategoryList />
              </PrivateCheck>
            }
          />
          <Route
            path="product/list"
            element={
              <PrivateCheck
                path={[
                  { title: '쇼핑몰 상품/재고 관리' },
                  { title: '상품 카테고리 관리' },
                ]}
              >
                <ProductCategoryList />
              </PrivateCheck>
            }
          />
          <Route
            path="request-list"
            element={
              <PrivateCheck
                path={[
                  { title: '카테고리 관리' },
                  { title: '카테고리 신청 목록' },
                ]}
              >
                <CategoryRequestList />
              </PrivateCheck>
            }
          />
        </Route>
        {/* 카테고리 끝 */}

        {/* 선물 관리 */}
        <Route path="gift">
          <Route
            index
            path="dashboard"
            element={
              <PrivateCheck
                path={[{ title: '선물 관리' }, { title: '대시보드' }]}
              >
                <GiftDashboard />
              </PrivateCheck>
            }
          />
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '선물 관리' }, { title: '선물 내역 목록' }]}
                >
                  <GiftList />
                </PrivateCheck>
              }
            />
            <Route
              path=":giftId"
              element={
                <PrivateCheck
                  path={[
                    { title: '선물 관리' },
                    { title: '선물 내역 상세정보' },
                  ]}
                >
                  <GiftDetail />
                </PrivateCheck>
              }
            />
          </Route>
          <Route path="products">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '선물 관리' }, { title: '선물 상품 목록' }]}
                >
                  <GiftProductList />
                </PrivateCheck>
              }
            />
            <Route
              path=":giftProductId"
              element={
                <PrivateCheck
                  path={[
                    { title: '선물 관리' },
                    { title: '선물 상품 상세정보' },
                  ]}
                >
                  <GiftProductDetail />
                </PrivateCheck>
              }
            />
          </Route>
          <Route
            index
            path="categories"
            element={
              <PrivateCheck
                path={[{ title: '선물 관리' }, { title: '선물 카테고리 관리' }]}
              >
                <GiftCategoryList />
              </PrivateCheck>
            }
          />
        </Route>
        {/* 선물 관리 끝 */}

        {/* 메뉴 */}
        <Route path="menu">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '매장 메뉴/재고 관리' },
                    { title: '매장 메뉴 목록' },
                  ]}
                >
                  <MenuList />
                </PrivateCheck>
              }
            />
            <Route
              path=":menuId"
              element={
                <PrivateCheck
                  path={[
                    { title: '매장 메뉴 관리' },
                    { title: '메뉴 상세정보' },
                  ]}
                >
                  <MenuDetail />
                </PrivateCheck>
              }
            />
          </Route>
          <Route
            path="register"
            element={
              <PrivateCheck
                path={[{ title: '매장 메뉴 관리' }, { title: '메뉴 등록' }]}
              >
                <MenuRegister />
              </PrivateCheck>
            }
          />
          <Route
            path="request-list"
            element={
              <PrivateCheck
                path={[
                  { title: '매장 메뉴 관리' },
                  { title: '메뉴 신청 목록' },
                ]}
              >
                <MenuRequestList />
              </PrivateCheck>
            }
          />
        </Route>
        {/* 메뉴 끝 */}

        {/* 태그 */}
        <Route path="tag">
          <Route
            path="list"
            element={
              <PrivateCheck
                path={[
                  { title: '쇼핑몰 상품/재고 관리' },
                  { title: '태그 목록' },
                ]}
              >
                <TagList />
              </PrivateCheck>
            }
          />
          <Route
            path="detail"
            element={
              <PrivateCheck
                path={[
                  { title: '쇼핑몰 상품/재고 관리' },
                  { title: '태그 상세정보' },
                ]}
              >
                <TagDetail />
              </PrivateCheck>
            }
          />
          <Route
            path="register"
            element={
              <PrivateCheck
                path={[
                  { title: '쇼핑몰 상품/재고 관리' },
                  { title: '태그 등록/수정' },
                ]}
              >
                <TagRegister />
              </PrivateCheck>
            }
          />
        </Route>
        {/* 태그 끝 */}

        {/* 추천검색어 */}
        <Route path="searchword">
          <Route
            path="list"
            element={
              <PrivateCheck
                path={[
                  { title: '쇼핑몰 상품/재고 관리' },
                  { title: '추천검색어 목록' },
                ]}
              >
                <SearchWordList />
              </PrivateCheck>
            }
          />
          <Route
            path="detail"
            element={
              <PrivateCheck
                path={[
                  { title: '쇼핑몰 상품/재고 관리' },
                  { title: '추천검색어 상세정보' },
                ]}
              >
                <SearchWordDetail />
              </PrivateCheck>
            }
          />
          <Route
            path="register"
            element={
              <PrivateCheck
                path={[
                  { title: '쇼핑몰 상품/재고 관리' },
                  { title: '추천검색어 등록/수정' },
                ]}
              >
                <SearchWordRegister />
              </PrivateCheck>
            }
          />
        </Route>
        {/* 추천 검색어 끝 */}

        {/* 주문관리 */}
        <Route path="order">
          <Route path="dashboard">
            <Route
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 쇼핑몰 주문 관리' },
                    { title: '쇼핑몰관리 홈' },
                  ]}
                >
                  <OrderDashboard />
                </PrivateCheck>
              }
            />
          </Route>
          <Route path="manual">
            <Route
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 주문 관리' },
                    { title: '주문장 생성' },
                  ]}
                >
                  <Manual auth={'ADMIN'} defaultShop={null} />
                </PrivateCheck>
              }
            />
            <Route
              path=":orderId"
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 주문 관리' },
                    { title: '주문장 수정' },
                  ]}
                >
                  <Manual auth={'ADMIN'} defaultShop={null} />
                </PrivateCheck>
              }
            />
          </Route>
          <Route path="list">
            <Route
              // path="list"
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 주문 관리' },
                    { title: '전체주문조회' },
                  ]}
                >
                  <OrderList />
                </PrivateCheck>
              }
            />
            <Route
              path=":order_type"
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 주문 관리' },
                    { title: '입금전 관리' },
                  ]}
                >
                  <OrderList />
                </PrivateCheck>
              }
            />
            {/* <Route
              path=":orderId"
              element={
                <PrivateCheck
                  path={[{ title: '쇼핑몰 주문 관리' }, { title: '주문 상세정보' }]}
                ></PrivateCheck>
              }
            /> */}
          </Route>
        </Route>
        <Route path="shipping">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '쇼핑몰 주문 관리' }, { title: '배송 목록' }]}
                >
                  <ShippingList />
                </PrivateCheck>
              }
            />
            <Route
              path="RENTAL"
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 주문 관리' },
                    { title: '렌탈상품관리' },
                  ]}
                >
                  <RentList />
                </PrivateCheck>
              }
            />
            <Route
              path="REGULAR"
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 주문 관리' },
                    { title: '정기배송관리' },
                  ]}
                >
                  <RegularList />
                </PrivateCheck>
              }
            />
            <Route
              path=":shipping_type"
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 주문 관리' },
                    { title: '배송 상태 관리' },
                  ]}
                >
                  <ShippingList />
                </PrivateCheck>
              }
            />
            {/* <Route
              path=":orderId"
              element={
                <PrivateCheck
                  path={[{ title: '쇼핑몰 주문 관리' }, { title: '배송 상세정보' }]}
                ></PrivateCheck>
              }
            /> */}
          </Route>
        </Route>
        <Route path="regular">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 주문 관리' },
                    { title: '정기배송 목록' },
                  ]}
                >
                  <RegularList />
                </PrivateCheck>
              }
            />
            <Route
              path=":orderId"
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 주문 관리' },
                    { title: '정기배송 상세정보' },
                  ]}
                ></PrivateCheck>
              }
            />
          </Route>
        </Route>
        <Route path="rent">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '쇼핑몰 주문 관리' }, { title: '렌탈 목록' }]}
                >
                  <RentList />
                </PrivateCheck>
              }
            />
            <Route
              path=":orderId"
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 주문 관리' },
                    { title: '렌탈 상세정보' },
                  ]}
                ></PrivateCheck>
              }
            />
          </Route>
        </Route>
        <Route path="payment">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '쇼핑몰 주문 관리' }, { title: '결제 목록' }]}
                >
                  <PaymentList />
                </PrivateCheck>
              }
            />
            <Route
              path=":orderId"
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 주문 관리' },
                    { title: '결제 상세정보' },
                  ]}
                ></PrivateCheck>
              }
            />
          </Route>
        </Route>
        <Route path="refund">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '쇼핑몰 주문 관리' }, { title: '환불 목록' }]}
                >
                  <RefundList />
                </PrivateCheck>
              }
            />
            <Route
              path=":orderId"
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 주문 관리' },
                    { title: '환불 상세정보' },
                  ]}
                ></PrivateCheck>
              }
            />
          </Route>
        </Route>
        {/* 주문관리 끝 */}

        {/* 관리자 관리 */}
        <Route path="manager">
          <Route
            path="list"
            index
            element={
              <PrivateCheck
                path={[{ title: '입점업체 관리' }, { title: '관리자 목록' }]}
              >
                <ManagerList />
              </PrivateCheck>
            }
          />
          <Route
            path=":adminId"
            element={
              <PrivateCheck
                path={[{ title: '입점업체 관리' }, { title: '관리자 등록' }]}
              >
                <ManagerRegister />
              </PrivateCheck>
            }
          />
        </Route>
        {/* 관리자 관리 끝 */}

        {/* 매출 관리 */}
        <Route path="jm-pay">
          {/* <Route path="dashboard"> */}
          {/* 대시보드 */}
          <Route
            index
            element={
              <PrivateCheck
                path={[
                  { title: 'JM페이' },
                  {
                    title: '대시보드',
                  },
                ]}
              >
                <JmPayDashboard />
              </PrivateCheck>
            }
          />
          <Route
            path="list"
            element={
              <PrivateCheck
                path={[
                  { title: 'JM페이' },
                  {
                    title: '사용 및 충전관리',
                  },
                ]}
              >
                <JmPay />
              </PrivateCheck>
            }
          />
          {/* </Route> */}
        </Route>

        {/* 매출 관리 */}
        <Route path="sales">
          <Route path="dashboard">
            {/* 대시보드 */}
            <Route
              index
              // path="jm-pay"
              element={
                <PrivateCheck
                  path={[
                    { title: '매장매출 관리' },
                    {
                      title: '대시보드',
                    },
                  ]}
                >
                  <SalesDashboard />
                </PrivateCheck>
              }
            />
            <Route
              index
              path=":type"
              element={
                <PrivateCheck
                  path={[
                    { title: '매장매출 관리' },
                    {
                      title: `${
                        (pathname === '/sales/dashboard/main' && '대시보드') ||
                        (pathname === '/sales/dashboard/daily' && '일자별') ||
                        (pathname === '/sales/dashboard/menu' && '메뉴별') ||
                        (pathname === '/sales/dashboard/option_period' &&
                          '옵션별') ||
                        (pathname === '/sales/dashboard/timezone' &&
                          '시간대별') ||
                        (pathname === '/sales/dashboard/payments' &&
                          '결제수단별') ||
                        (pathname === '/sales/dashboard/menu_category' &&
                          '카테고리별')
                      }`,

                      // pathname === '/sales/dashboard/menu'
                      //   ? '메뉴별'
                      //   : pathname === '/sales/dashboard/daily'
                      //   ? '일자별'
                      //   : '결제수단별',
                    },
                  ]}
                >
                  <SaleDashboard />
                </PrivateCheck>
              }
            />
            {/* 분류별 통계 [daily, menu, payment] */}
            <Route
              path=":type"
              element={
                <PrivateCheck
                  path={[{ title: '매출 관리' }, { title: '일자별' }]}
                >
                  <SaleDashboard />
                </PrivateCheck>
              }
            />
          </Route>

          <Route
            path="register"
            element={
              <PrivateCheck
                path={[{ title: '매출 관리' }, { title: '주문장 생성' }]}
              >
                <SaleRegister />
              </PrivateCheck>
            }
          />

          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '매출 관리' }, { title: '매출 목록' }]}
                >
                  <SaleList />
                </PrivateCheck>
              }
            />
            <Route
              path=":salesId"
              element={
                <PrivateCheck
                  path={[{ title: '매출 관리' }, { title: '매출 상세정보' }]}
                >
                  <SaleDetail />
                </PrivateCheck>
              }
            />
          </Route>
        </Route>
        <Route path="store-sales">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '매출 관리' }, { title: '매출 목록' }]}
                >
                  <SaleList />
                </PrivateCheck>
              }
            />
            <Route
              path=":salesId"
              element={
                <PrivateCheck
                  path={[{ title: '매출 관리' }, { title: '매출 상세정보' }]}
                >
                  <SaleDetail />
                </PrivateCheck>
              }
            />
          </Route>
        </Route>
        {/* 매출 관리 끝 */}

        {/* 쇼핑몰 장바구니 관리 */}
        <Route path="cart">
          <Route
            path="analyze"
            element={
              <PrivateCheck
                path={[
                  { title: '쇼핑몰 장바구니 관리' },
                  { title: '쇼핑몰 장바구니 분석' },
                ]}
              >
                <CartAnalyze />
              </PrivateCheck>
            }
          />
          <Route
            path="settings"
            element={
              <PrivateCheck
                path={[
                  { title: '쇼핑몰 장바구니 관리' },
                  { title: '쇼핑몰 장바구니 설정' },
                ]}
              >
                <CartSettings />
              </PrivateCheck>
            }
          />
          <Route
            path="list"
            index
            element={
              <PrivateCheck
                path={[
                  { title: '쇼핑몰 장바구니 관리' },
                  { title: '쇼핑몰 장바구니 분석' },
                ]}
              >
                <CartList />
              </PrivateCheck>
            }
          />
        </Route>
        {/* 쇼핑몰 장바구니 관리 끝 */}

        {/* 통계 관리 */}
        <Route path="statistics">
          <Route path="list">
            <Route
              index
              element={
                <PrivateCheck
                  path={[{ title: '통계 관리' }, { title: '대시보드' }]}
                >
                  <StatisticList />
                </PrivateCheck>
              }
            />
            <Route
              path=":statisticsId"
              element={
                <PrivateCheck
                  path={[{ title: '통계 관리' }, { title: '통계 상세정보' }]}
                >
                  <StatisticDetail />
                </PrivateCheck>
              }
            />
          </Route>
          <Route
            path="dashboard"
            element={
              <PrivateCheck
                path={[{ title: '통계 관리' }, { title: '대시보드' }]}
              >
                <StatisticDashboard />
              </PrivateCheck>
            }
          />
        </Route>
        {/* 통계 관리 끝 */}

        {/* 문의 관리 */}
        <Route path="inquiry">
          <Route
            path="list"
            index
            element={
              <PrivateCheck
                path={[{ title: '게시판 관리' }, { title: '문의 목록' }]}
              >
                <InquiryList />
              </PrivateCheck>
            }
          ></Route>
          <Route
            path="faq"
            element={
              <PrivateCheck
                path={[{ title: '게시판 관리' }, { title: 'FAQ 목록' }]}
              >
                <InquiryList FAQ />
              </PrivateCheck>
            }
          ></Route>
        </Route>
        {/* 문의 관리 끝 */}

        {/* 메시지 관리 */}
        <Route path="message">
          <Route path="dashboard">
            <Route
              index
              element={
                <PrivateCheck>
                  <MessageDashboard />
                </PrivateCheck>
              }
            />
          </Route>
          <Route path="list">
            <Route
              path=":messageType"
              element={
                <PrivateCheck>
                  <NotificationList />
                </PrivateCheck>
              }
            />
          </Route>

          <Route
            path=":messageType"
            element={
              <PrivateCheck>
                <PushManager />
              </PrivateCheck>
            }
          />

          <Route
            path="template"
            element={
              <PrivateCheck
                path={[{ title: '메시지 관리' }, { title: '템플릿 관리' }]}
              >
                <MessageTemplate />
              </PrivateCheck>
            }
          />
        </Route>
        <Route
          path="alim-talk"
          element={
            <PrivateCheck
              path={[{ title: '메시지 관리' }, { title: '알림톡 관리' }]}
            >
              <AlimTalk />
            </PrivateCheck>
          }
        />
        {/* 메시지 관리 끝 */}

        {/* SECTION 쇼핑몰 매출 관리 */}
        <Route path="shop">
          <Route path="sales">
            <Route
              index
              path="dashboard"
              element={
                <PrivateCheck
                  path={[{ title: '쇼핑몰 매출 관리' }, { title: '대시보드' }]}
                >
                  <ShopSalesDashboard />
                </PrivateCheck>
              }
            />
            <Route
              path=":type"
              element={
                <PrivateCheck
                  path={[
                    { title: '쇼핑몰 매출 관리' },
                    {
                      title: `${
                        (pathname === '/shop/sales/daily' && '일자별') ||
                        (pathname === '/shop/sales/products' && '상품별') ||
                        (pathname === '/shop/sales/timezone' && '시간대별') ||
                        (pathname === '/shop/sales/payments' && '결제수단별') ||
                        (pathname === '/shop/sales/category' && '카테고리별')
                      }`,
                    },
                  ]}
                >
                  <ShopSales defaultShop={null} auth={'ADMIN'} />
                </PrivateCheck>
              }
            />
          </Route>
        </Route>
        {/* !SECTION 쇼핑몰 매출 관리 */}
      </Routes>
    </AdminLayout>
  );
};

export default AdminRoutes;
